//@flow
import React, { Fragment } from 'react';
import { Nav, NavItem } from 'reactstrap';
import { Link, withRouter } from 'react-router-dom';

type Props = {
  isViewingOwnProfile: boolean,
  match: Object,
  location: Object,
};

const navs = [
  {
    name: 'Profile',
    url: 'profile',
    icon: 'user',
  },
  {
    name: 'Treks',
    url: 'treks',
    icon: 'profile-trek-old',
  },
  {
    name: 'Purchase List',
    url: 'purchase-list',
    icon: 'shopping-cart',
  },
];

function NavBar(props: Props) {
  const {
    isViewingOwnProfile,
    location: { pathname },
  } = props;

  return isViewingOwnProfile ? (
    <Fragment>
      <Nav tabs className="v-tabs">
        {navs.map(({ name, url, icon }) => (
          <NavItem key={name}>
            <Link
              to={`${props.match.url}/${url}`}
              className={pathname.includes(url) ? 'nav-link active' : 'nav-link'}
            >
              <i className={`icon icon-hg-${icon}`} />
              <span className="name">{name}</span>
            </Link>
          </NavItem>
        ))}
      </Nav>
      <hr />
    </Fragment>
  ) : null;
}

export default withRouter(NavBar);



// WEBPACK FOOTER //
// ./src/screens/Profile/NavBar.jsx